import React from 'react';
import { reduxForm, Form, getFormValues } from 'redux-form';

import DownloadIcon from '@material-ui/icons/SaveAlt';
import AddIcon from '@material-ui/icons/Add';

import documentsIcon from '../../../assets/img/matched/documents_icon.png';

import {
  Dropzone,
  Button,
  Grid,
  Select,
  TextField,
  FilePreview,
  Translation,
  CircularProgress,
} from '../../common';
import { connectTo } from '../../../utils/';

import { PDF, DOC, DOCX, JPEG, PNG } from '../../../constants/file-upload';

import { error } from '../../../utils/toastr';

const SELECT_VALUES = [
  'VOUCHER',
  'CONFIRMATION_OF_TERMINATION',
  'CERTIFICATE_OF_REGISTRATION',
  'COPY_OF_INVOICE',
  'DEATH_CERTIFICATE',
  'OTHER',
].map((value) => ({
  value,
  label: `UPLOAD_FILE_TYPE_${value}`,
  id: `page.post-box.component.upload-select.${value}-item`,
}));

const ACCEPTED_TYPES = [PDF, DOC, DOCX, JPEG, PNG];
const MAX_SIZE = 100 * 1024 * 1024; // 100 Mb
const MAX_FILE_COUNT = 10;

const filesCheck = (files) => !!files && !!files.length;
const fileValidator = (files) =>
  filesCheck(files) ? undefined : 'Files are required';

const typeCheck = (type) => !!type;
const typeValidator = (type) =>
  typeCheck(type) ? undefined : 'Type is required';

class UploadFileModalContent extends React.Component {
  onFileRemove = (file) => () => {
    const { change, values } = this.props;
    if (values.files && values.files.length) {
      const filesCopy = values.files.slice();
      const fileIdx = filesCopy.indexOf(file);
      filesCopy.splice(fileIdx, 1);
      change('files', filesCopy);
    }
  };

  onDropzoneFileExcess = (fileNames) => {
    error(
      `Some files are excessing max file size: ${fileNames.join(
        ', '
      )}! They were filtered.`
    );
  };

  render() {
    const {
      handleSubmit,
      styles,
      values,
      invalid,
      isFileLoading,
      translations,
    } = this.props;
    const hasFiles = values && values.files && values.files.length;

    return (
      <Form onSubmit={handleSubmit} className={styles['upload-file-modal']}>
        <div className={styles['upload-file-modal__header']}>
          <h1 className={styles['upload-file-modal__header-text']}>
            <Translation>UPLOAD_FILE_DIALOG_TITLE</Translation>
          </h1>
          <img
            className={styles['upload-file-modal__header-image']}
            src={documentsIcon}
            alt="upload-file"
          />
        </div>
        <Grid
          container
          spacing={4}
          justify="space-between"
          className={styles['upload-file-modal__content']}
        >
          <Grid
            item
            sm={7}
            container
            direction="column"
            spacing={2}
            className={styles['upload-file-modal__content-files']}
          >
            {isFileLoading ? (
              <Grid
                item
                container
                alignItems="center"
                justify="center"
                className={styles['upload-file-modal__loader-wrapper']}
              >
                <CircularProgress
                  className={styles['upload-file-modal__loader']}
                />
              </Grid>
            ) : (
              <>
                {(hasFiles && (
                  <Grid
                    item
                    className={styles['upload-file-modal__content-files-array']}
                  >
                    {values.files.map((file, key) => (
                      <FilePreview
                        file={file}
                        onRemove={this.onFileRemove(file)}
                        removeButtonId="page.postbox.component.file-upload-modal.file-remove-button"
                        key={key}
                      />
                    ))}
                  </Grid>
                )) ||
                  null}
                {!(hasFiles && values.files.length === MAX_FILE_COUNT) ? (
                  <Grid
                    item
                    xs
                    className={styles['upload-file-modal__content-files-item']}
                  >
                    <Dropzone
                      name="files"
                      maxFileCount={MAX_FILE_COUNT}
                      maxSize={MAX_SIZE}
                      accept={ACCEPTED_TYPES}
                      className={styles['upload-file-modal__content-dropzone']}
                      id="page.postbox.component.upload-file-modal.file-dropzone"
                      validate={fileValidator}
                      multiple
                      multipleAdding
                      onMaxSizeExcess={this.onDropzoneFileExcess}
                    >
                      <Translation
                        className={
                          styles['upload-file-modal__content-dropzone-text']
                        }
                      >
                        UPLOAD_EXPLANATION
                      </Translation>
                      <AddIcon
                        className={
                          styles['upload-file-modal__content-dropzone-icon']
                        }
                      />
                    </Dropzone>
                  </Grid>
                ) : null}
              </>
            )}
          </Grid>
          <Grid
            item
            sm={5}
            className={styles['upload-file-modal__content-options']}
          >
            <div className={styles['upload-file-modal__content-field']}>
              <div className={styles['upload-file-modal__content-label']}>
                <Translation>{'UPLOAD_FILE_TITLE'}</Translation>
              </div>
              <Select
                name="type"
                validate={typeValidator}
                className={styles['upload-file-modal__content-type']}
                options={SELECT_VALUES}
                translated
              />
            </div>
            <div className={styles['upload-file-modal__content-field']}>
              <div className={styles['upload-file-modal__content-label']}>
                <Translation>UPLOAD_FILE_DESCIPTION</Translation>
              </div>
              <TextField
                name="description"
                className={styles['upload-file-modal__content-description']}
                placeholder={
                  translations &&
                  translations['UPLOAD_FILE_DESCIPTION_PLACEHOLDER']
                }
                multiline
                rows={5}
              />
            </div>
            <Button
              id="page.postbox.component.upload-file-modal.upload-file-button"
              className={styles['upload-file-modal__button']}
              type="submit"
              disabled={invalid || isFileLoading}
            >
              <DownloadIcon
                className={styles['upload-file-modal__button-icon']}
              />
              <span>
                <Translation>UPLOAD_BUTTON</Translation>
              </span>
            </Button>
          </Grid>
        </Grid>
      </Form>
    );
  }
}

const UPLOAD_FILES_FORM = 'upload-files';

const connected = connectTo(
  (state) => ({
    values: getFormValues(UPLOAD_FILES_FORM)(state),
  }),
  {},
  UploadFileModalContent
);

export default reduxForm({
  form: UPLOAD_FILES_FORM,
})(connected);
